import React, { ReactNode } from "react";
import { twMerge } from "tailwind-merge";

export interface Props {
  className?: string;
  children: ReactNode;
  mobileHide?: boolean;
}

const TableCell = ({ className, children, mobileHide = false }: Props) => {
  return (
    <div
      className={twMerge(
        "align-middle lg:border-b p-3 lg:p-5",
        className,
        mobileHide ? "hidden md:table-cell" : "lg:table-cell",
      )}
    >
      {children}
    </div>
  );
};

export default TableCell;
